import React from "react";
import Page from "../components/Page";

// Import
import { useSelector } from "react-redux";
import GrabElement from "../components/GrabElement";

// Import for Display
import RichText from "../components/RichText";
import LoadingPage from "./LoadingPage";
import LoginPage from "./LoginPage";
import Lightbox from "../components/Lightbox";

function GalleryPage() {
  // Accessing Data.
  const { data } = useSelector((state) => state.cms);

  const collectionSlug = "galleries";
  const collectionData = data[collectionSlug];
  

  const { user } = useSelector((state) => state.auth);
  if (!user) return <LoginPage />;
  const element = GrabElement(collectionData, user.currentRole)


  // Only load if data has returned.

  if (!collectionData) return <LoadingPage />;

  return (
    <Page data-wf-page="635934a8e598deacd00a5b71" data-wf-site="634efd6b20b65bfc05be44e4">
      <div className="section wf-section">
        <div className="container w-container">
          <div>
            <h1>{element.attributes.title}</h1>
            <RichText text={element.attributes.body} />
          </div>
        </div>
      </div>
      <div className="section wf-section">
        <div className="container w-container">
          <div className="w-layout-grid gridlightbox">
            {/* Render our lightboxes. */}
            {element &&
              element.attributes.photos.data.map((item) => {
                return (
                  <Lightbox
                    group="a"
                    aClass="lightbox w-inline-block w-lightbox"
                    imgClass="imagelightbox"
                    imgSrc={item.attributes.url}
                    href="#"
                    id="w-node-_6029fa1c-9190-0c6c-7c35-258df31071da-f31071da"
                  />
                );
              })}
          </div>
        </div>
      </div>
    </Page>
  );
}

export default GalleryPage;
